import * as React from 'react';

import { calculatePreviousTotal, calculateTotal, TransactionType } from '../../providers/TransactionsProvider';

import ChangeIndicator from './ChangeIndicator';

import type { CalendarDateRange } from '../DateRangePicker';
import type { ColumnTable } from 'arquero';

const getVersusText = (periodType: 'month' | 'year' | null): string | null => {
  if (periodType === 'month') {
    return 'vs last month';
  } else if (periodType === 'year') {
    return 'vs last year';
  }
  return null;
};

export interface ITransactionChangeIndicatorProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  className?: string;
  type?: TransactionType;
}

const TransactionChangeIndicator = ({
  transactions,
  dateRange,
  className,
  type = TransactionType.Spending,
}: ITransactionChangeIndicatorProps) => {
  const currentTotal = React.useMemo(() => calculateTotal(transactions, dateRange), [transactions, dateRange]);

  const previousResult = React.useMemo(
    () => calculatePreviousTotal(transactions, dateRange),
    [transactions, dateRange]
  );

  const versusText = getVersusText(previousResult.periodType);

  if (!versusText || previousResult.value === 0) {
    return null;
  }

  const isIncome = type === TransactionType.Income;
  const multiplier = isIncome ? -1 : 1;

  return (
    <ChangeIndicator
      current={currentTotal * multiplier}
      previous={previousResult.value * multiplier}
      versusText={versusText}
      increaseGood={isIncome}
      className={className}
    />
  );
};

export default TransactionChangeIndicator;
